import * as types from './index';
import sellerApi from '~/app/apis/seller.api';
import { defaultMessageError } from '~/app/constants';
import { iGetAllSeller, iUpdateStatusSeller } from '~/app/models';

const { rest } = types;

export const getData = (payload: iGetAllSeller) => async (dispatch: any) => {
  dispatch(rest.getDataPending());
  const controller = new AbortController();
  dispatch(rest.changeController(controller));
  try {
    const res = await sellerApi.getAllSeller(payload);
    const { data } = res;
    !data ? dispatch(rest.getDataRejected(defaultMessageError)) : dispatch(rest.getDataFulfilled(data));
  } catch (error: any) {
    if ((error.name = 'CanceledError')) {
      return dispatch(rest.getDataPending());
    }
    const { message } = error?.response?.data || defaultMessageError;
    dispatch(rest.getDataRejected(message));
  }
};

export const getUpdateStatus = (idPayload: iUpdateStatusSeller, payload: iGetAllSeller) => async (dispatch: any) => {
  dispatch(rest.getUpdateStatusPending());
  try {
    const res = await sellerApi.updateStatusSeller(idPayload);
    const { data } = res;
    !data ? dispatch(rest.getUpdateStatusRejected(defaultMessageError)) : dispatch(rest.getUpdateStatusFulfilled());
    dispatch(getData(payload));
  } catch (error: any) {
    if ((error.name = 'CanceledError')) {
      return dispatch(rest.getUpdateStatusPending());
    }
    const { message } = error?.response?.data || defaultMessageError;
    dispatch(rest.getUpdateStatusRejected(message));
  }
};

export const setUrlData = (payload: { pageSize: number; currentPage: number }) => (dispatch: any) => {
  dispatch(rest.setUrlData(payload));
};

export const setIsDESC = (isDESC: boolean) => (dispatch: any) => {
  dispatch(rest.setIsDESC(isDESC));
};

export const setKeySearch = (keySearch: string) => (dispatch: any) => {
  dispatch(rest.setKeySearch(keySearch));
};

export const setFilterData = (filterData: any) => (dispatch: any) => {
  dispatch(rest.setFilterData(filterData));
};

export const setQueryString = (queryString: string) => (dispatch: any) => {
  dispatch(rest.setQueryString(queryString));
};

export const setQueryOrderString = (queryString: string) => (dispatch: any) => {
  dispatch(rest.setQueryOrderString(queryString));
};

export const setQueryCartString = (queryString: string) => (dispatch: any) => {
  dispatch(rest.setQueryCartString(queryString));
};

export const setQueryReviewString = (queryString: string) => (dispatch: any) => {
  dispatch(rest.setQueryReviewString(queryString));
};

export const resetSellerQueryString = () => (dispatch: any) => {
  dispatch(rest.resetQueryString());
};

export const clearData = () => (dispatch: any) => {
  dispatch(rest.clearData());
};

export const setIsEnableFilter = (isEnableFilter: boolean) => (dispatch: any) => {
  dispatch(rest.setIsEnableFilter(isEnableFilter));
};
